import { hasChat } from "config";

export const isChatEnabled = () => hasChat();